type IRequestError = {
  response: Error;
};

export const isRequestError = (error: unknown): error is IRequestError => {
  if (typeof error === "object" && error !== null && "response" in error && error.response instanceof Error) {
    return true;
  }
  return false;
};
